import * as React from "react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { useIsSmallScreen } from "@/hooks/use-device"

const MobileTabletNotice: React.FC = () => {
  const isSmall = useIsSmallScreen()
  const [open, setOpen] = React.useState(false)
  const [dismissed, setDismissed] = React.useState(false)

  React.useEffect(() => {
    // Check if user has already dismissed this notice in this session
    const hasSeenNotice = sessionStorage.getItem('dashboard-mobile-notice-seen')
    if (isSmall && !hasSeenNotice && !dismissed) {
      setOpen(true)
    }
  }, [isSmall, dismissed])

  const handleDismiss = () => {
    setOpen(false)
    setDismissed(true)
    sessionStorage.setItem('dashboard-mobile-notice-seen', 'true')
  }

  if (!isSmall || dismissed) return null

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Best experienced on a laptop</AlertDialogTitle>
          <AlertDialogDescription>
            This application is optimized for desktop and laptop screens. For the best and most complete UI, please open it on a laptop or desktop device.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleDismiss}>Continue anyway</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default MobileTabletNotice
